import { CAT_WEBSITE_DEALS } from 'App/utils/Collections';
import { FT_DATE, FT_CHECKBOX, FT_LIST, FT_AUTOCOMPLETE, FT_SINGLE } from '../FilterTypes';
import { getDealTypes } from '@/models/form-models/helpers';

import {
  statusItemsLoader,
  loadLocations,
  searchCourierDeliveryServices,
  searchCustomers,
  searchProjects,
  loadWebsiteDeals,
} from './loaders';

const EXCLUDED_DEAL_ID = [1, 21, 34, 61];

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  tracking: {
    name: 'Tracking',
    groupOrderIndex: 1,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 2,
  },
};

export default {
  category: CAT_WEBSITE_DEALS,
  filters: [
    {
      id: 'dealItems.item.wimsId',
      label: 'Product ID',
      type: FT_SINGLE,
      group: groups.general,
    },
    {
      id: 'dealItems.item.name',
      label: 'Product name',
      type: FT_SINGLE,
      group: groups.general,
    },
    {
      id: 'project.id',
      label: 'Project',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: searchProjects,
      },
    },
    {
      id: 'status.id',
      label: 'Status',
      type: FT_LIST,
      group: groups.general,
      getListItems: async () => {
        const statuses = await getDealTypes();
        return statusItemsLoader(statuses.filter((el) => !EXCLUDED_DEAL_ID.includes(el.id)).map((el) => el.id));
      },
    },
    {
      id: 'customer.id',
      label: 'Customer',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: searchCustomers,
      },
    },
    {
      id: 'type.id',
      label: 'Websites',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        items: loadWebsiteDeals,
      },
    },
    {
      id: 'urgent',
      label: 'Urgent',
      fieldConf: {
        label: 'Urgent delivery',
      },
      group: groups.tracking,
      type: FT_CHECKBOX,
      defaultValue: () => false,
    },
    {
      id: 'createdAt',
      label: 'Created at',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'updatedAt',
      label: 'Updated at',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'trackingParcels.countryOfDeparture.id',
      label: 'Departure country',
      type: FT_AUTOCOMPLETE,
      group: groups.tracking,
      fieldConf: {
        searcher: loadLocations,
      },
    },
    {
      id: 'trackingParcels.countryOfDestination.id',
      label: 'Destination country',
      type: FT_AUTOCOMPLETE,
      group: groups.tracking,
      fieldConf: {
        searcher: loadLocations,
      },
    },
    {
      id: 'trackingParcels.courierDeliveryService.id',
      label: 'Delivery services',
      type: FT_AUTOCOMPLETE,
      group: groups.tracking,
      fieldConf: {
        searcher: searchCourierDeliveryServices,
      },
    },
  ],
  searchBarProp: 'complex_name',
};
